import _                from 'lodash';
import moment           from 'moment';
import * as Cookie      from 'js-cookie';  // eslint-disable-line

import endPointPath     from '../../global/endPointPath';

import emailActions     from './emailActions';
import calendarActions  from './calendarActions';
import templatesActions from './templatesActions';
import langueActions    from './langueActions';
import sessionActions   from './sessionActions';
import emailOrderActions from './emailOrderActions';

import {productFormation} from '../../organisms/MainShop/constants';
import getTemplates from '../selectors/getTemplates';

const dataThunks = {};

dataThunks.sendEmail = (data) => (dispatch) =>
  new Promise ((resolve, reject) => {
    dispatch(emailActions.sendEmailStart());

    const payload = {
      'name'    : data.get('name'),
      'email'   : data.get('email'),
      'message' : data.get('message'),
    };

    const endPoint = endPointPath.email + process.env.REACT_APP_EMAIL;

    const encoded = Object.keys(payload).map(function(k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(payload[k]);
    }).join('&');

    fetch(endPoint, {
      method  : 'POST',
      body    : encoded,
      headers : new Headers({'Content-Type': 'application/x-www-form-urlencoded'}),
    })
      .then((response) => response.json())
      .catch((error) => {
        dispatch(emailActions.sendEmailFail());
        reject(error);
      })
      .then((response) => {
        const result = response.result;
        console.warn('End of call:', result);
        if (result === 'error') {
          dispatch(emailActions.sendEmailFail());
          reject(result.error);
        }
        else {
          dispatch(emailActions.sendEmailSuccess());
          resolve();
        }
      });
  });

dataThunks.getCalendar = () => (dispatch) =>
  new Promise ((resolve, reject) => {
    dispatch(calendarActions.getCalendarStart());

    const endPoint = `${endPointPath.calendar}${process.env.REACT_APP_CALENDAR_ID}/events?key=${process.env.REACT_APP_API_KEY}`;

    fetch(endPoint, {method: 'GET'})
      .then((response) => response.json())
      .catch((error) => {
        console.error('Error:', error);
        dispatch(emailActions.getCalendarFail());
        reject(error);
      })
      .then((response) => {
        if (response && _.has(response,'items')) {
          const result = response.items;

          const events = result.map((event) => ({
            calendar    : response.description,
            description : event.description,
            start       : moment(event.start.date || event.start.dateTime).toDate(),
            end         : moment(event.end.date || event.end.dateTime).toDate(),
            title       : event.summary,
            location    : event.location,
          }));

          dispatch(calendarActions.getCalendarSuccess(events));
          resolve();
        }
        else {
          dispatch(calendarActions.getCalendarFail());
          reject();
        }
      });
  });

dataThunks.getTemplates = () => (dispatch) =>
  new Promise ((resolve, reject) => {
    const endPoint = endPointPath.getTemplates;
    console.log('endPoint', endPoint);
    dispatch(templatesActions.getTemplatesStart());

    const HEADERS = {
      method  : 'GET',
      headers : {
        'Access-Control-Allow-Origin' : '*',
        'Accept'                      : 'application/json',
        'Content-Type'                : 'application/json',
      },
      mode: 'cors',
    };

    fetch(endPoint, {...HEADERS})
      .then((response) => response.json())
      .then((response) => {
        if (response && Object.keys(response).length) {
          dispatch(templatesActions.getTemplatesSuccess(response));
          resolve();
        }
        else {
          dispatch(templatesActions.getTemplatesFail());
          reject();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        dispatch(templatesActions.getTemplatesFail());
        reject(error);
      });
  });

dataThunks.setTemplates = (lang = 'fr') => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const endPoint = endPointPath[lang === 'fr' ? 'setTemplatesFr' : 'setTemplatesEn'];

    dispatch(templatesActions.getTemplatesStart());

    const token = getState().getIn(['session','token']);
    const template = getState().getIn(['langue', 'tempTemplates', lang]);
    const HEADERS = {
      method  : 'POST',
      headers : {
        'Access-Control-Allow-Origin' : '*',
        'Accept'                      : 'application/json',
        'Authorization'               : 'Token ' + token,
        'Content-Type'                : 'application/json',
      },
      mode : 'cors',
      body : JSON.stringify(template),
    };

    fetch(endPoint, {...HEADERS})
      .then((response) => response.json())
      .catch((error) => {
        console.error('Error:', error);
        dispatch(templatesActions.getTemplatesFail());
        reject(error);
      })
      .then((response) => {
        if (response && Object.keys(response).length) {
          dispatch(langueActions.saveSuccessTemplates());
          resolve();
        }
        else {
          dispatch(templatesActions.getTemplatesFail());
          reject();
        }
      });
  });

dataThunks.login = ({username = '', password = ''}) => (dispatch) =>
  new Promise((resolve, reject) => {
    if (!username || !password) {
      reject('Username and password cannot be empty !');
    }
    else {
      dispatch(sessionActions.loginStart());

      const endPoint = endPointPath.login;

      const HEADERS = {
        method  : 'POST',
        headers : {
          'Access-Control-Allow-Origin' : '*',
          'Accept'                      : 'application/json',
          'Content-Type'                : 'application/json',
        },
        mode : 'cors',
        body : JSON.stringify({
          username,
          password,
        }),
      };

      fetch(endPoint, {...HEADERS})
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error);
          dispatch(sessionActions.loginFail());
          reject(error);
        })
        .then((response) => {
          if (!response.token) {
            dispatch(sessionActions.loginFail());
            reject('Wrong username or password');
          }
          else {
            // Set cookie
            Cookie.set('token', response.token, {
              path    : '/',
              expires : 7, // 7 days
            });

            dispatch(sessionActions.loginSuccess(response.token));
            resolve();
          }
        });
    }
  });

dataThunks.createPayment = (actions, productId, currency, products, promo) => (dispatch) =>
  new Promise((resolve, reject) => {
    dispatch;
    if (typeof productId !== 'number' || !products || !products[productId]) {
      reject(new Error('Product is missing a price', ...arguments));
      return;
    }

    const {price, priceEuro, promoCode, title} = products[productId];
    let newPrice = currency === '$' ? price : priceEuro;
    if (promoCode && promo) {
      const promoValue = promoCode.find((p) => p.code === promo);
      if (promoValue) {
        const percent = 1 - (promoValue.rebate / 100);
        newPrice = Math.floor(newPrice * percent) || 0.01;
      }
    }

    const order = actions.order.create({
      purchase_units: [
        {
          description : `Formation: ${title[0]}`,
          amount      : {
            currency_code : currency === '$' ? 'USD' : 'EUR',
            value         : newPrice,
          },
        },
      ],
      application_context: {shipping_preference: 'NO_SHIPPING'},
    });
    resolve(order);
  });

dataThunks.sendOrderEmail = (data, productID, price) => (dispatch, getState) =>
  new Promise ((resolve, reject) => {
    dispatch(emailOrderActions.sendEmailStart(productID));
    const lang = getTemplates(getState());

    const productList = productFormation(lang);
    const product = productList[productID];

    if (!product) {
      dispatch(emailOrderActions.sendEmailFail(productID));
      reject(new Error('Missing product'));
    }
    else {
      const {
        status,
        customerEmail,
        payer_id,
        customerName : {given_name, surname},
        currency,
        transactionID,
      } = data;
      status;
      payer_id;
      currency;

      const payload = {
        'keyEmail'    : process.env.REACT_APP_EMAIL,
        'ordernumber' : transactionID,
        'firstname'   : given_name,
        'lastname'    : surname,
        'product'     : product.title[0],
        'videos'      : product.video || [],
        'to'          : customerEmail,
        'template'    : 'order',
        'atm'         : product.atm || [],
        'price'       : price || 0.01,
      };

      if (product.contentTemplate) {
        payload.contentTemplate = product.contentTemplate;
      }

      const endPoint = endPointPath.emailOrder;

      fetch(endPoint, {
        headers: {
          'Access-Control-Allow-Origin' : '*',
          'Accept'                      : 'application/json',
          'Content-Type'                : 'application/json',
        },
        method : 'POST',
        mode   : 'cors',
        body   : JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then(() => {
          dispatch(emailOrderActions.sendEmailSuccess(productID));
          resolve();
        })
        .catch((error) => {
          dispatch(emailOrderActions.sendEmailFail(productID, 'Mail send error'));
          reject(error);
        });
    }
  });

export default dataThunks;



// WEBPACK FOOTER //
// ./src/store/actions/dataThunks.js